/**
 * Names to be used as storage item keys
 */
enum StorageItem {
	FULLSCREEN_ALLOWED = "fullscreenAllowed",
	PROVIDER = "provider",
	REFRESH_TOKEN_CREATION = "refreshTokenCreation",
	REFRESH_TOKEN = "refreshToken",
	ACCESS_TOKEN = "accessToken",
	ID_TOKEN = "idToken",
	DROPZONE = "dropzone",
	NEWS = "newsPanel",
	LANGUAGE = "i18nextLng",
	OAUTH_ERROR = "oauthError",
	OAUTH_REDIRECT = "oauthRedirect",
	OAUTH_VERIFIER = "pkce_code_verifier",
	OAUTH_STATE = "pkce_state",
	UNIT = "lengthUnit",
	SESSION_CLOSE = "session_close"
}

export default StorageItem;